module.exports = __webpack_public_path__ + "img/img2.332ec6dd.jpg";